export interface ParentFormConfigField {
  fieldId: string;
  label: string;
  type:
    | 'text'
    | 'number'
    | 'date'
    | 'boolean'
    | 'select'
    | 'multiselect'
    | 'time';
  required: boolean;
  options?: Array<Option>;
  defaultValue?: string | number | boolean;
  order: number;
  visible: boolean;
  section?: Section;
}

export interface Option {
  value: string;
  label: string;
}

export enum Section {
  Address = 'Address',
  EmergencyContacts = 'Emergency Contacts',
  GeneralInfo = 'General Info',
  Students = 'Students',
}

// export class CreateFormParentPreferenceDto {
//   studioId?: Types.ObjectId;
//   formFields: Array<{
//     fieldId: string;
//     label: string;
//     type:
//       | 'text'
//       | 'number'
//       | 'date'
//       | 'boolean'
//       | 'select'
//       | 'multiselect'
//       | 'time';
//     required: boolean;
//     options?: Array<string>;
//     defaultValue?: any;
//     order: number;
//     visible: boolean;
//     section?: string;
//   }>;
//   isActive?: boolean;
//   entity: string;
// }
